export class ToolOpinionModel {
    tool: { id: number; name: string }
    uniqueColor: string;
    safety: number;
    efficacy: number;

    constructor(tool: { id: number; name: string }, uniqueColor: string, safety: number, efficacy: number) {
        this.tool = tool;
        this.uniqueColor = '#' + uniqueColor;
        this.safety = safety;
        this.efficacy = efficacy;
    }
}
